import {React} from 'external/react'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faFileExcel, faFileCsv} from "@fortawesome/free-solid-svg-icons"

const icons = {faFileExcel, faFileCsv}

export default function Icon({name}) {
  return <FontAwesomeIcon icon={icons[name]} />
}
